<template>
  <component :is="component"/>
</template>

<script>
import StepOneIcon from '@/common/components/application/step-icons/StepOneIcon';
import StepTwoIcon from '@/common/components/application/step-icons/StepTwoIcon';
import StepThreeIcon from '@/common/components/application/step-icons/StepThreeIcon';
import StepFourIcon from '@/common/components/application/step-icons/StepFourIcon';
import StepFiveIcon from '@/common/components/application/step-icons/StepFiveIcon';

export default {
  name: 'StepIcon',

  props: {
    stepNumber: {
      type: String,
      required: true
    }
  },

  components: {
    StepOneIcon,
    StepTwoIcon,
    StepThreeIcon,
    StepFourIcon,
    StepFiveIcon
  },

  computed: {
    component () {
      return `step-${this.stepNumber}-icon`
    }
  }
}
</script>
